// extracted by mini-css-extract-plugin
module.exports = {"marquee":"marquee_marquee__NzvSe","marquee__inner":"marquee_marquee__inner__zfUx8","marquee__content":"marquee_marquee__content__0rozK"};